export const ListLayoutTypes = {
    socialList: {
        key: "SocialList",
        label: "Social List"
    },
    smallList: {
        key: "SmallList",
        label: "Small List"
    },
    mediumList: {
        key: "MediumList",
        label: "Medium List"
    },
    twoColumnList: {
        key: "TwoColumnList",
        label: "2 Column List"
    },
    polaroid: {
        key: "LargeMag",
        label: "Polaroid"
    },
    miniPolaroid: {
        key: "MiniPolaroid",
        label: "Mini Polaroid"
    },
    gallery: {
        key: "Gallery",
        label: "Gallery"
    },
    letterbox: {
        key: "Letterbox",
        label: "Letterbox"
    },
    headline: {
        key: "Headline",
        label: "Headline"
    },
    feedMag: {
        key: "Feed",
        label: "Feed Mag"
    }
};

export type ListLayoutKey = typeof ListLayoutTypes[keyof typeof ListLayoutTypes]["key"];
export type ListLayoutValue = typeof ListLayoutTypes[keyof typeof ListLayoutTypes];